import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'


// 🚨 核心：引入 Element Plus 的全局基础样式
import 'element-plus/dist/index.css'

const app = createApp(App)

app.use(router)

app.mount('#app')
